<div *ngIf="product" class="catalog-container">
    <!-- Header -->
    <div class="header">
      <!-- Breadcrumbs -->
      <div class="breadcrumbs">
        <!-- Go Back Action -->
        <button class="action-btn secondary-btn icon-btn" (click)="cancel()">
          <span class="icon">
            <img src="assets/icones/close_icon.svg" alt="" />
          </span>
        </button>
        <span>
          <div class="breadcrumb-item">
            {{
              "inventory.inventory"
                | translate
            }}
          </div>
        </span>
        <img src="assets/icones/arrow_to_right.svg" alt="" />
        <span class="catalog-name">{{ product.name }}</span>
        <ui-status-badge
          size="big"
          [tone]="statusTone(product)"
          [label]="getStatusTranslation(product.status)"
        ></ui-status-badge>
  
      </div>

      <!-- View Details Action -->
      <button
        class="view-btn"
        (click)="viewDetails()"
        [matTooltip]="'inventory.product_details.view_as_customer' | translate"
        matTooltipPosition="below"
        [attr.aria-label]="'inventory.product_details.view_as_customer' | translate"
      >
        <span class="icon">
          <img src="assets/icones/view-eyes.svg" alt="" />
        </span>
      </button>
    </div>
    <!-- Content -->
    <div class="catalog-content">
      <!-- Left Panel -->
      <div class="left-panel">
        <div class="header">{{ 'inventory.details' | translate }}</div>
        <div class="content">
          <app-product-informations
          [product]="product"
          ></app-product-informations>
        </div>
      </div>
      <div class="right-panel">
        <div class="tabs">
          <div
            class="tab"
            role="tab"
            [attr.aria-selected]="activeTab === 'insights'"
            [class.active]="activeTab === 'insights'"
            (click)="activeTab = 'insights'"
          >
          {{ "inventory.insights.insights" | translate }}
          </div>
          <div
            class="tab"
            role="tab"
            [attr.aria-selected]="activeTab === 'inventory_tab'"
            [class.active]="activeTab === 'inventory_tab'"
            (click)="activeTab = 'inventory_tab'"
          >
          {{ "inventory.inventory_tab.title" | translate }}
          </div>
          <div
            class="tab"
            role="tab"
            [attr.aria-selected]="activeTab === 'catalogs'"
            [class.active]="activeTab === 'catalogs'"
            (click)="activeTab = 'catalogs'"
          >
          {{ "inventory.catalogs.catalogs" | translate }}
          </div>
        </div>
        <div class="tab-content-wrapper">
          <ng-container *ngIf="activeTab === 'insights'">
            <app-insights></app-insights>
          </ng-container>
          <ng-container *ngIf="activeTab === 'inventory_tab'">
            <app-inventory [product]="product"></app-inventory>
          </ng-container>
          <ng-container *ngIf="activeTab === 'catalogs'">
            <app-catalogs
            [product]="product"
            ></app-catalogs>
          </ng-container>
        </div>
      </div>
    </div>
  </div>